import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { getListResult } from "../../../utils";
import NoMncModal, { UploadNoMNCDocumentDetails } from "../components/NoMncModal";
import { getDischargeReason } from "../../../actions/Master";
import { putUploadNoMNCDocumentDetails } from "../../../actions/Patient";
import { uploadDocumentFile } from "../../../actions/ReferralAction";
import { resetStates } from "../../../actions/Common";

const mapStateToProps = ({
  loggedInUserState,
  dischargeReasonState,
  noMncDetailsState,
  documentUploadState
}: ApplicationState) => ({
  loggedInUser: loggedInUserState.response,
  dischargeReason: getListResult(dischargeReasonState.response),
  noMncDetails: noMncDetailsState.response,
  documentUploadErrorState: documentUploadState.error,
  documentUploadState: documentUploadState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getDischargeReason: () => {
      dispatch(getDischargeReason());
    },
    putUploadNoMNCDocumentDetails: (payload: UploadNoMNCDocumentDetails) => {
      dispatch(putUploadNoMNCDocumentDetails(payload));
    },
    uploadDocumentFile: (payload: any) => {
      dispatch(uploadDocumentFile(payload));
    },
    resetStates: (actionType: string, field?: string) => {
      dispatch(resetStates(actionType, field));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoMncModal);
